import { GROWTHBOOK_LOADED } from '../../constants/experiment';

export const setGrowthBookLoaded = () => ({
  type: GROWTHBOOK_LOADED,
});
